import { acceptedPaymentMethod } from '../../types/customer.types';

type DigitalWalletMethod = 'click_to_pay' | 'google_pay' | 'apple_pay';

export type PaymentMethod = acceptedPaymentMethod | DigitalWalletMethod;

type PaymentMethodKey = 'credit_card' | DigitalWalletMethod;

export type PaymentMethodDetails = Partial<
  Record<PaymentMethodKey, Record<string, unknown>>
>;

export type PaymentPayload = {
  payments: Array<
    { payment_method: PaymentMethod } & PaymentMethodDetails
  >;
  quote_id?: string;
};

export type BuildPaymentPayloadOptions = {
  details?: PaymentMethodDetails;
  quoteId?: string;
};

export function buildPaymentPayload(
  paymentMethod: PaymentMethod,
  { details, quoteId }: BuildPaymentPayloadOptions = {}
): PaymentPayload {
  const payload: PaymentPayload = {
    payments: [
      {
        payment_method: paymentMethod,
        ...details,
      },
    ],
  };

  if (quoteId) {
    payload.quote_id = quoteId;
  }

  return payload;
}
